module.exports = __webpack_public_path__ + "static/media/zew.4b52dba3.svg";